import Constants from '@/Constants';
import useStore from '@/store';

function VersionMonitor() {
  const { appVersion } = useStore();
  const deviceId = localStorage.getItem('device-id');
  return (
    <div className="min-w-100px absolute bottom-8 right-8 z-topmost flex flex-col items-center rounded-lg bg-neutral-grey-2 px-4 py-2">
      <p className="w-fit text-sm text-neutral-grey-4">{`${appVersion}(${Constants.APP_VERSION})`}</p>
      <p className="text-sm text-neutral-grey-4">{Constants.GIT_INFO}</p>

      <p className="text-sm text-neutral-grey-4">{`Device id: ${deviceId}`}</p>
    </div>
  );
}

export default VersionMonitor;
